import React from 'react';
import { motion } from 'framer-motion';

const TimelineItem = ({ time, title, description, category, isLast, delay = 0 }) => {
  const categoryColors = {
    racing: 'border-primary text-primary',
    robotics: 'border-secondary text-secondary',
    experience: 'border-accent text-accent',
    stage: 'border-orange-500 text-orange-500',
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay }}
      className="relative flex items-start space-x-6 pb-12"
      data-testid={`timeline-item-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {/* Timeline Line */}
      {!isLast && (
        <div className="absolute left-6 top-12 bottom-0 w-px bg-gradient-to-b from-primary/50 to-transparent" />
      )}

      {/* Timeline Dot */}
      <div className="relative flex-shrink-0">
        <div className="w-12 h-12 rounded-full border-2 border-primary bg-background flex items-center justify-center neon-glow">
          <div className="w-4 h-4 rounded-full bg-primary" />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 pt-1">
        <div className="flex flex-wrap items-center gap-3 mb-2">
          <span className="text-lg font-heading font-bold text-primary">{time}</span>
          {category && (
            <span
              className={`px-3 py-1 text-xs font-bold uppercase tracking-wider border ${
                categoryColors[category] || 'border-primary text-primary'
              } bg-background/50`}
            >
              {category}
            </span>
          )}
        </div>
        <h4 className="text-xl font-heading font-bold text-foreground mb-2">{title}</h4>
        {description && (
          <p className="text-muted-foreground leading-relaxed">{description}</p>
        )}
      </div>
    </motion.div>
  );
};

export default TimelineItem;
